export const FETCHER_MODE = {
  DRUPAL: "drupal",
  MIDDLEWARE: "middleware",
    PUBLIC_S3: "public_s3"
};
